<modal-sidebar (closeModal)="close()" [visible]="isSidebarPromptuaryOpen">
	<div header>
		<div *ngIf="unifiedPromptuary.isLoading">
			<h1 class="sidebar__loading">{{ 'GENERAL.LOADING' | translate }}</h1>
		</div>
		<div *ngIf="!unifiedPromptuary.isLoading">
			<div class="zk-mb-2">
				<div class="zk-flex zk-gap-2 zk-items-center">
					<appointment-type-badge
						[subscriptionType]="
							appointment?.compensationInfo?.subscription?.type || null
						"
					></appointment-type-badge>
				</div>
			</div>
			<div class="zk-mb-2">
				<div class="zk-flex zk-gap-2 zk-items-center">
					<h1 class="freud-icon freud-icon-user-circle freud-icon-lg"></h1>
					<h1 class="sidebar__user">{{ appointment?.userName }}</h1>
				</div>
			</div>
			<div class="zk-flex zk-gap-2 zk-items-center">
				<span class="freud-icon freud-icon-calendar-event"></span>
				<span class="sidebar__date">{{ formatedDate }}</span>
			</div>
		</div>
	</div>
	<ng-container body *ngIf="isSidebarPromptuaryOpen">
		<div
			*ngIf="unifiedPromptuary.isLoading"
			class="zk-h-full zk-flex zk-items-center zk-justify-center"
		>
			<freud-loader size="lg"></freud-loader>
		</div>
		<div *ngIf="!unifiedPromptuary.isLoading && unifiedPromptuary.isPromptuaryCreated">
			<promptuary-form
				[from]="from"
				[mainType]="mainType"
				*ngIf="promptuaryType === 'default' && appointmentId"
				[appointmentId]="appointmentId"
				[psychotherapist]="psychotherapist"
				[psychologist]="psychologist"
				(cancel)="close()"
				[isAssistanceJourney]="isAssistanceJourney"
				[clientId]="contactId"
				[promptuary]="promptuary"
				(pageLoaded)="unifiedPromptuary.isLoading = false"
				type="sidebar"
			></promptuary-form>
		</div>
	</ng-container>
</modal-sidebar>
